<template>
    <div class="polygon-map-wrapper d-flex flex-column align-items-end w-100 gap-2 border-radius-10 common-box-shadow">
        <primaryButtonComponent buttonType="submit" @click="resetMap" class="large-text mt-4" buttonWidth="max-content" paddingY="10px" paddingX="18px">
            <template v-slot:content>
                reset
            </template>
        </primaryButtonComponent>
        <div id="map" :style="[{'--max-height': maxHeight}]">

        </div>
    </div>
</template>
<script>
import { Loader } from "@googlemaps/js-api-loader"
import primaryButtonComponent from "@/components/primaryButtonComponent.vue";
import { toRaw, isProxy } from "vue";
export default {
    data(){
        return {
            map: null,
            center: { lat: 42.01674161706719, lng: 44.070112500000015 },
            drawingManager: null,
            polygon: null,
            marker: null,
        }
    },
    props: {
        maxHeight: {
            type: String,
            default: "500px",
        },
        allowedDrawingTools: {
            type: Array,
            default: ['polygon'],
        }
    },
    components: {
        primaryButtonComponent,
    },
    mounted() {
        this.loadMapsJavascriptApi();
    },
    methods: {
        async resetMap(){
            if(this.polygon != null || this.marker != null){
                // this.polygon.visible = false;
                // this.polygon.zIndex = -99;
                
                // await google.maps.event.clearListeners(this.polygon.getPath(), 'insert_at');
                // await google.maps.event.clearListeners(this.polygon.getPath(), 'remove_at');
                // await google.maps.event.clearListeners(this.polygon, 'dragend');
                // await this.polygon.setMap(null);
                // this.polygon = null;
                if(this.drawingManager){
                    // await this.drawingManager.setOptions({
                    //     drawingControlOptions: {
                    //         position: google.maps.ControlPosition.TOP_CENTER,
                    //         drawingModes: [
                    //             google.maps.drawing.OverlayType.POLYGON,
                    //         ],
                    //     },
                    // });
                    await this.drawingManager.setMap(null);
                    // await google.maps.event.clearListeners(this.drawingManager, 'polygoncomplete');
                    this.drawingManager = null;
                }
                // await google.maps.event.clearListeners(this.map, 'zoom_changed');
                // await google.maps.event.clearListeners(this.map, 'click');
                // await google.maps.event.clearListeners(this.map);
                document.getElementById('map').innerHTML = '';
                this.map = null;
                this.$emit("updatePolygon", null);
                this.$emit("updateMarker", null);
                await this.initMap();
            }
        },
        async initDrawingManager(){
            const {DrawingManager} = await google.maps.importLibrary("drawing");
            this.drawingManager = new DrawingManager({
                drawingMode: null,
                drawingControl: true,
                drawingControlOptions: {
                    position: google.maps.ControlPosition.TOP_CENTER,
                    drawingModes: this.allowedDrawingTools,
                    // google.maps.drawing.OverlayType.MARKER,
                    // google.maps.drawing.OverlayType.CIRCLE,
                    // google.maps.drawing.OverlayType.POLYGON,
                    // google.maps.drawing.OverlayType.POLYLINE,
                    // google.maps.drawing.OverlayType.RECTANGLE,
                },
                polygonOptions: {
                    fillColor: '#ff0000',
                    fillOpacity: 0.5,
                    strokeWeight: 2,
                    clickable: true,
                    editable: true,
                    zIndex: 1,
                    draggable: true,
                    geodesic: true,
                }
            });
            this.drawingManager.setMap(toRaw(this.map));

            google.maps.event.addListener(this.drawingManager, 'polygoncomplete', (polygon) => {
                this.polygon = polygon;
                
                // const path = this.polygon.getPath();
                // path.forEach(function(latLng, index) {
                //     console.log('Point ' + index + ': ' + latLng.lat() + ', ' + latLng.lng());
                // });

                // google.maps.event.addListener(polygon.getPath(), 'set_at', (e) => {
                //     console.log('Polygon vertex edited.');
                // });

                google.maps.event.addListener(this.polygon.getPath(), 'insert_at', (e) => {
                    this.$emit("updatePolygon", this.polygon);
                });

                google.maps.event.addListener(this.polygon.getPath(), 'remove_at', (e) => {
                    this.$emit("updatePolygon", this.polygon);
                });
                google.maps.event.addListener(this.polygon, 'dragend', (e) => {
                    this.$emit("updatePolygon", this.polygon);
                });

                toRaw(this.drawingManager).setOptions({
                    drawingMode: null,
                    drawingControlOptions: {
                        position: google.maps.ControlPosition.TOP_CENTER,
                        drawingModes: [],
                    },
                });
                toRaw(this.drawingManager).setMap(null);
                this.$emit("updatePolygon", this.polygon);
                
            });
            google.maps.event.addListener(this.drawingManager, 'markercomplete', (marker) => {
                this.marker = marker;
                this.marker.setDraggable(true);
                // console.log('Marker complete:', marker);
                // marker.setTitle("New Marker");
                
                this.marker.addListener('dragend', (event) => {
                    this.$emit("updateMarker", toRaw(this.marker));
                });
                this.$emit("updateMarker", toRaw(this.marker));
                toRaw(this.drawingManager).setOptions({
                    drawingMode: null,
                    drawingControlOptions: {
                        position: google.maps.ControlPosition.TOP_CENTER,
                        drawingModes: [],
                    },
                });
                toRaw(this.drawingManager).setMap(null);
            });
        },
        async initMap(){
            // const { Map } = await google.maps.importLibrary("maps");
            // const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");
            this.map = await new google.maps.Map(document.getElementById("map"), {
                zoom: 16,
                center: this.center,
                mapId: "map",
                zoomControl: true,
                mapTypeControl: false,
                scaleControl: true,
                streetViewControl: false,
                rotateControl: true,
                fullscreenControl: true,
                minZoom: 8,
                mapTypeId: "roadmap",
            });
            const bounds = await new google.maps.LatLngBounds(
                await new google.maps.LatLng(41.055166, 40.006810),
                await new google.maps.LatLng(43.586370, 46.736076),
            );
            await google.maps.event.addListenerOnce(toRaw(this.map), 'idle', () => {
                toRaw(this.map).fitBounds(bounds);
                toRaw(this.map).setZoom(8);
            });
            await this.initDrawingManager();
        },
        async loadMapsJavascriptApi(){
            const loader = new Loader({
                apiKey: "AIzaSyAAKLfrixiIVwDf2VU31OdWZuxQswrTNA0",
                version: "beta",
                language: "GE",
                region: "GE",
                authReferrerPolicy: "origin",
            });
            await loader.importLibrary('maps').then(({Map}) => {
                this.initMap();
            })
            .catch((e) => {
                document.getElementById("map").textContent = "რუკა ვერ ჩაიტვირთა, დაფიქსირდა შეცდომა";
            });
        },
    }
}
</script>
<style scoped>
.polygon-map-wrapper{
    padding: 10px 20px 20px 20px;
    background-color: var(--secondary-background-color);
}
#map{
    height: var(--max-height);
    width: 100%;
}
</style>
